<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div
  class="preferred-communication-channel-container profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row"
  [attr.aria-busy]="isLoading ? 'true' : 'false'"
>
  <div class="profile:mb-fluid-sm profile:md:mb-0 profile:w-full profile:md:w-1/3 profile:lg:w-1/4 profile:md:pe-static-md">
    <profile-pds-p-text class="profile:text-[14px]" p-text size="inherit" color="contrast-medium">
      <div [innerHTML]="'pidp.personalData.preferredCommunicationChannel.description.label' | translate"></div>
    </profile-pds-p-text>
  </div>
  <div class="profile:w-full profile:md:w-3/4 profile:lg:w-1/2">
    @if (isLoading) {
      <div role="status" aria-live="polite">
        <span class="profile:sr-only">{{ 'pidp.personalData.preferredCommunicationChannel.loading.status' | translate }}</span>
      </div>
    }
    <div class="preferred-communication-items profile:flex profile:flex-col profile:md:flex-row">
      <div
        class="preferred-communication-item profile:me-0 profile:mb-fluid-sm profile:lg:me-static-md profile:md:pe-static-sm profile:md:w-1/2"
      >
        <div class="profile:flex profile:flex-row">
          <profile-pds-p-radio-group
            p-radio-group
            [value]="preferredCommunicationChannel === 'EMAIL' ? 'EMAIL' : ''"
            (change)="updateCommunicationChannel($event, 'EMAIL')"
            [disabled]="isLoading || isRestricted || !isValid('EMAIL')"
            [attr.aria-label]="groupAriaLabelKey('EMAIL') | translate"
          >
            <profile-pds-p-radio-group-option
              p-radio-group-option
              [attr.aria-labelledby]="labelDomId('EMAIL')"
              [attr.aria-describedby]="messageIdFor('EMAIL')"
              [value]="'EMAIL'"
            ></profile-pds-p-radio-group-option>
          </profile-pds-p-radio-group>
          <span
            [id]="labelDomId('EMAIL')"
            class="profile:ps-static-sm profile:pe-static-sm"
            [ngClass]="{ 'profile:cursor-default profile:text-contrast-medium': !isValid('EMAIL') }"
          >
            {{ getCommunicationChannelTranslationKeyFor('EMAIL', 'label') | translate }}
          </span>
        </div>
        @if (messageKeyFor('EMAIL'); as emailMessageKey) {
          <profile-pds-p-text
            p-text
            [attr.id]="messageDomId('EMAIL')"
            size="sm"
            class="profile:pt-fluid-sm"
            [ngClass]="{ 'profile:cursor-default profile:text-contrast-medium': !isValid('EMAIL') }"
            [color]="'inherit'"
            >{{ emailMessageKey | translate }}</profile-pds-p-text
          >
        }
      </div>
      <div class="preferred-communication-item profile:md:w-1/2">
        <div class="profile:flex profile:flex-row">
          <profile-pds-p-radio-group
            p-radio-group
            [value]="preferredCommunicationChannel === 'SMS' ? 'SMS' : ''"
            (change)="updateCommunicationChannel($event, 'SMS')"
            [disabled]="isLoading || isRestricted || !isValid('SMS')"
            [attr.aria-label]="groupAriaLabelKey('SMS') | translate"
          >
            <profile-pds-p-radio-group-option
              p-radio-group-option
              [attr.aria-labelledby]="labelDomId('SMS')"
              [attr.aria-describedby]="messageIdFor('SMS')"
              [value]="'SMS'"
            ></profile-pds-p-radio-group-option>
          </profile-pds-p-radio-group>
          <span
            [id]="labelDomId('SMS')"
            class="profile:ps-static-sm"
            [ngClass]="{ 'profile:cursor-default profile:text-contrast-medium': !isValid('SMS') }"
            >{{ getCommunicationChannelTranslationKeyFor('SMS', 'label') | translate }}</span
          >
        </div>
        @if (messageKeyFor('SMS'); as smsMessageKey) {
          <profile-pds-p-text
            p-text
            [attr.id]="messageDomId('SMS')"
            size="sm"
            class="profile:md:text-balance profile:pt-fluid-sm"
            [ngClass]="{ 'profile:cursor-default profile:text-contrast-medium': !isValid('SMS') }"
            [color]="'inherit'"
            >{{ smsMessageKey | translate }}</profile-pds-p-text
          >
        }
      </div>
    </div>
  </div>
</div>
